import React from 'react'
import {checkboxHolderStyle} from './checkbox-holder-style'
import {Form} from 'semantic-ui-react'

const defaultViewInput = (customAccessFieldOnChange, defaultView) => {
  return (
    <div style={checkboxHolderStyle}>
      <b>Default view on Cads Page:</b>
      <Form.Group widths='equal' style={{textAlign: 'center'}}>
        <Form.Input name='defaultView' type="text" label='' onChange={customAccessFieldOnChange} placeholder='{status: "ALL", sort: "Created At", visible: ["PO","Hold"]}' value={defaultView}
          style={{width: '500px'}} />
      </Form.Group>
    </div>
  )
}

export {defaultViewInput}
